var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { MenuItem as MuiMenuItem } from '@mui/material';
import React, { forwardRef } from 'react';
import { red01, red03 } from '../../colors/red';
import { isLightTheme } from '../../utils/utils';
var MenuItem = forwardRef(function (_a, ref) {
    var danger = _a.danger, className = _a.className, children = _a.children, props = __rest(_a, ["danger", "className", "children"]);
    var newProps = __assign({}, props);
    delete newProps.filterable;
    return (React.createElement(MuiMenuItem, __assign({ sx: function (theme) { return (__assign({}, (danger && { color: isLightTheme(theme) ? red03 : red01 }))); } }, __assign({ ref: ref }, newProps)), children));
});
MenuItem.displayName = 'MenuItem';
export default MenuItem;
